export const SOKETI_RELOAD_EVENTS = 'reload-event';
